import {createSvgIcon} from '../create-svg-icon';

export const HeightIcon = createSvgIcon(
  <path d="M13 6.99h3L12 3 8 6.99h3v10.02H8L12 21l4-3.99h-3z" />
, 'HeightOutlined');
